<template>
    <div>
        <div class="site" v-for="(item, index) in siteList" :key="index" @click="$router.push({ name : 'SiteDetail', query : { site_id : item.id }})">
            <van-image  width="2.5rem" height="2.5rem" fit="cover" radius='5px' :src="item.image_src"></van-image>
            <van-row style="width: calc(100% - 2.8rem); float: right">
                <van-col span="16" class="title">{{item.name}}</van-col>
                <van-col span="8" class="km">{{item.distance | distanceDataFormat}}</van-col>
                <van-col span="16" class="score"></van-col>
                <van-col span="8" @click.stop="navigation(item)">
                    <icon class="icon" name="daohang"></icon>
                </van-col>
                <van-col span="24" style="color:#999;">电话:{{item.telphone}}</van-col>
            </van-row>
        </div>
    </div>
</template>

<script>
    import wx from 'weixin-js-sdk';
    import api from "../../assets/js/api";
    import common from "../../assets/js/common";

    export default {
        name: "Index",
        data(){
            return {
                siteList : [],
            };
        },
        created() {
            this.refresh();
        },
        methods : {
            refresh(){
                let self = this;
                common.wechatReady(function () {
                    wx.getLocation({
                        type: 'wgs84',
                        success: function (locationRes) {
                            api.request('/site/list', {
                                longitude : locationRes.longitude,
                                latitude : locationRes.latitude,
                            }).then(res => {
                                self.siteList = res.data;
                            });
                        },
                        fail: function(err) {
                            self.$notify({ type: 'danger', message: '获取定位位置信息失败，请稍后再试' });
                        },
                        cancel: function (res) {
                            self.$notify({ type: 'danger', message: '用户拒绝授权获取地理位置' });
                        },
                    });
                });
            },
            navigation(detail){
                wx.openLocation({
                    latitude: detail.latitude,
                    longitude: detail.longitude,
                    name: detail.name,
                    address: detail.address,
                    scale: 16
                });
            },
        }
    }
</script>

<style scoped>
    .site {
        margin-bottom: 10px;
        background: #fff;
        padding: 10px 15px;
    }
    .title {
        font-size: 16px;
        font-weight: bold;
        line-height: 20px;
        text-overflow:ellipsis;
        white-space: nowrap;
        overflow:hidden;
        margin-top: 2px;
    }

    .km {
        text-align: right;
        font-size: 14px;
        color: #38A1F2
    }

    .score {
        margin-top: 2px;
        line-height: 16px;
    }

    .icon {
        width:35px;
        height:35px;
        float: right;
    }
</style>



// WEBPACK FOOTER //
// src/pages/site/Index.vue